module.exports = {
      id: "premium-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#premium",
      toString: function () {
        return this.url;
      }
    }